import { render, staticRenderFns } from "./MRegisterEmailEdit.vue?vue&type=template&id=c2871f4c&scoped=true&"
import script from "./MRegisterEmailEdit.vue?vue&type=script&lang=ts&"
export * from "./MRegisterEmailEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2871f4c",
  null
  
)

export default component.exports